import { render, staticRenderFns } from "./OrdersTitle.vue?vue&type=template&id=168e3eb8&scoped=true"
import script from "./OrdersTitle.vue?vue&type=script&lang=js"
export * from "./OrdersTitle.vue?vue&type=script&lang=js"
import style0 from "./OrdersTitle.vue?vue&type=style&index=0&id=168e3eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168e3eb8",
  null
  
)

export default component.exports